export const htmlFontSize = 10 // The root font size
